import IState from '../models/IState';
import { createSelector } from "reselect";
import moment from 'moment'
import config from '../../helpers/config.helper';
import { formatUtcToLocal } from '../../constants/common.constant';
import { filterInitialState } from '../state/iaqDevices.state';

const appConfig = config();
const dateTimeFormat = appConfig.REACT_APP_DATE_TIME_FORMAT;

const stateIAQSensorData = (state: IState) => state.iaqSensorData.sensorDataList.datas;
const getSensor = (state: IState) => state.iaqDevices.dashboardSensorsFilter.sensor;

export const allIAQSensorData = createSelector(
    stateIAQSensorData,
    (datas) => {
        if (datas) {
            if (datas.IAQSensorData) {
                datas.IAQSensorData.map((item: any) => {
                    item.ICCID = datas.ICCID;
                    item.CreateTime = formatUtcToLocal(item.CreatedAt)
                    return item
                });
            }
            return datas;
        }
        return [];
    }
)

export const getIAQFilterSensorSelector = createSelector(
    getSensor,
    (sensor) => {
        let finalSensor = JSON.parse(JSON.stringify(filterInitialState));
        if (sensor !== null) {
            finalSensor.Building = sensor.Building;
            finalSensor.Comments = sensor.Comments;
            finalSensor.CustomerId = sensor.CustomerId;
            finalSensor.Floor = sensor.Floor;
            finalSensor.ICCID = sensor.ICCID;
            finalSensor.Location = sensor.Location;
            finalSensor.Room = sensor.Room;
            finalSensor.User = sensor.User;
            finalSensor.UserId = sensor.UserId;
            finalSensor.SensorType = 0; //Fixed typefor sensor iaq that is 0
            finalSensor.LatestPayloadStartDateTime = sensor.LatestPayloadStartDateTime;
            finalSensor.LatestPayloadEndDateTime = sensor.LatestPayloadEndDateTime;
        }
        return finalSensor;
    }
)